<template>
  <div class="h-full w-full flex items-center justify-center px-6 py-8">
    <div class="w-full max-w-[280px]">
      <div class="mb-8 flex items-center justify-center gap-4">
        <div
          v-for="idx in 4"
          :key="idx"
          class="h-4 w-4 rounded-full transition-colors"
          :class="idx <= pin.length ? 'bg-gray-500' : 'bg-gray-300'"
        />
      </div>

      <div class="grid grid-cols-3 gap-4">
        <b-button
          v-for="digit in digits"
          :key="digit"
          type="button"
          class="h-16 w-16 justify-self-center rounded-full border border-gray-400 text-2xl font-medium text-gray-900 transition hover:bg-gray-50 active:scale-95"
          @click="handleDigit(digit)"
        >
          {{ digit }}
        </b-button>

        <b-button
          icon="backspace"
          class="h-14 w-14 justify-self-center"
          aria-label="Go back"
          @click="handleBack"
        />

        <b-button
          type="button"
          class="h-16 w-16 justify-self-center rounded-full border border-gray-400 text-2xl font-medium text-gray-900 transition hover:bg-gray-50 active:scale-95"
          @click="handleDigit(0)"
        >
          0
        </b-button>

        <b-button
          icon="check"
          class="h-14 w-14 justify-self-center"
          :primary="isPinCorrect"
          :disabled="!isPinCorrect"
          aria-label="Confirm PIN"
          @click="handleConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { BButton } from '@booksy-com/vue-components-core'

const emit = defineEmits(['resolve'])

// Implementation for the purposes of the PoC — the final solution will be on the API side
const CORRECT_PIN = '1234'
const digits = [1, 2, 3, 4, 5, 6, 7, 8, 9]
const pin = ref('')

const isPinCorrect = computed(() => pin.value === CORRECT_PIN)

const handleDigit = (digit) => {
  if (pin.value.length >= 4) return

  pin.value += String(digit)

  if (pin.value.length === 4 && !isPinCorrect.value) {
    pin.value = ''
  }
}

const handleBack = () => {
  pin.value = pin.value.slice(0, -1)
}

const handleConfirm = () => {
  if (!isPinCorrect.value) return
  emit('resolve')
}
</script>
